import {
  Box,
  Typography,
  useTheme,
} from '@mui/material';
import { usePartnerProfileConfig } from '../Enrollment/usePartnerProfileConfig';

export const PartnerIntroSection = () => {
  const theme = useTheme();
  const { introduction } = usePartnerProfileConfig();
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1),
      }}
    >
      <Typography variant='h4'
        data-testid={`partners-individual-${introduction.title}-introduction`}
      >About {introduction.title}</Typography>
      <Typography variant='body8' color={theme.palette.grey[700]}>
        {introduction.description}
      </Typography>
    </Box>
  );
};
